/* 100X Equine Joint Flex Canine buy box + gallery behaviors (desktop and tablet).
   Ported from gutx-buy-box.js. Prices come from data attributes rendered by Liquid (live
   variant + selling-plan-allocation prices, in cents). One size tier (SKU JFC100) and one
   delivery button per selling plan the variant carries. No React, no Babel. */
(function () {
  var root = document.querySelector('[data-gx-buybox]');
  if (!root) return;
  /* TWO BUY BOXES SHIP ON THIS PAGE, gated by breakpoint: the jointflexcanine-v4 mobile page
     renders under 750px, this one renders at 750px and up. Only the VISIBLE one may initialise.

     window.GX_GET_SELECTION is read by the OCU bridge (assets/gx-ocu-bridge.js) to decide what to
     add to the cart, so a hidden box must never export it or bind its add. offsetParent is null
     for a display:none element, which is the cheapest reliable visibility test here. */
  if (!root.offsetParent) return;


  var money = function (cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  };

  var $ = function (sel) { return root.querySelector(sel); };
  var setText = function (sel, text) { var el = $(sel); if (el) el.textContent = text; };
  var show = function (sel, on) { var el = $(sel); if (el) el.style.display = on ? '' : 'none'; };

  // The single size button carries the variant id, the one-time price and one data-sub<days>
  // attribute per delivery plan, all rendered from the JFC100 variant.
  var sizeBtn = $('[data-gx-size] button');
  if (!sizeBtn) return;
  var cadenceBtns = root.querySelectorAll('[data-gx-cadence] button');
  var modeLabels = root.querySelectorAll('[data-gx-mode]');

  // Default cadence is the button Liquid marked on (90 days when that plan exists, else the first
  // plan), so no day count is typed here.
  var cadOn = $('[data-gx-cadence] button[data-on="true"]') || cadenceBtns[0];
  var state = { cadence: cadOn ? cadOn.getAttribute('data-cadence') : '', mode: 'one' };  // default: one-time (subscribe is the upsell); matches the initial markup

  function subPrice() {
    return Number(sizeBtn.getAttribute('data-sub' + state.cadence) || 0);
  }

  function render() {
    var oneTime = Number(sizeBtn.getAttribute('data-onetime'));
    var sub = subPrice();
    var isSub = state.mode === 'sub';
    var strikeOn = sub > 0 && oneTime > sub;

    // Subscribe savings badge = the selected plan's allocation price vs the one-time price.
    var pct = (oneTime && sub) ? Math.round((1 - sub / oneTime) * 100) : 0;
    var badgeEl = $('[data-gx-mode-badge]');
    if (badgeEl) {
      badgeEl.textContent = 'Save ' + pct + '%';
      badgeEl.style.display = pct > 0 ? '' : 'none';
    }

    // Mode prices: Subscribe strikes the one-time price; one-time shows its own price only.
    setText('[data-gx-mode-sub-now]', money(sub));
    var subStrikeEl = $('[data-gx-mode-sub-strike]');
    if (subStrikeEl) {
      subStrikeEl.textContent = strikeOn ? money(oneTime) : '';
      subStrikeEl.style.display = strikeOn ? '' : 'none';
    }
    setText('[data-gx-mode-one-now]', money(oneTime));

    // Mode selected state
    modeLabels.forEach(function (l) {
      l.setAttribute('data-on', l.getAttribute('data-gx-mode') === state.mode ? 'true' : 'false');
    });

    // Cadence field only in sub mode
    show('[data-gx-cadence-field]', isSub);
    cadenceBtns.forEach(function (b) {
      b.setAttribute('data-on', b.getAttribute('data-cadence') === state.cadence ? 'true' : 'false');
    });
    var cadLabel = $('[data-gx-cadence-label]');
    if (cadLabel && state.cadence) cadLabel.innerHTML = '&middot; every ' + state.cadence + ' days';

    // CTA
    var price = isSub ? sub : oneTime;
    setText('[data-gx-cta-label]', isSub ? 'Subscribe & Save' : 'Add to Cart');
    setText('[data-gx-cta-price]', money(price));

    // pause/cancel reassure line only in sub
    show('[data-gx-sub-only]', isSub);

    // Includes blocks
    show('[data-gx-included-sub]', isSub);
    show('[data-gx-included-one]', !isSub);

    // Sticky bar (tablet widths). Its product name is static markup: one size only.
    setText('[data-gx-mbb-now]', money(price));
    var mbbStrike = $('[data-gx-mbb-strike]');
    if (mbbStrike) {
      mbbStrike.textContent = (isSub && strikeOn) ? money(oneTime) : '';
      mbbStrike.style.display = (isSub && strikeOn) ? '' : 'none';
    }
    setText('[data-gx-mbb-cta]', isSub ? 'Subscribe & Save' : 'Add to Cart');
  }

  // ----- events -----
  cadenceBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.cadence = b.getAttribute('data-cadence'); render(); });
  });
  modeLabels.forEach(function (l) {
    l.addEventListener('click', function () { state.mode = l.getAttribute('data-gx-mode'); render(); });
  });

  // ----- add to cart -----
  // data-plans maps day count -> selling plan id, rendered from the variant's allocations.
  var plans = {};
  try { plans = JSON.parse(root.getAttribute('data-plans') || '{}'); } catch (e) {}

  function currentPlan() {
    return state.mode === 'sub' ? (plans[state.cadence] || null) : null;
  }

  // Current selection, read by the OCU slide-cart bridge (assets/gx-ocu-bridge.js). OCU does
  // the actual add when it is installed, so it needs the variant + plan selected right now.
  window.GX_GET_SELECTION = function () {
    return {
      variantId: sizeBtn.getAttribute('data-variant-id'),
      sellingPlanId: currentPlan()
    };
  };

  function addToCart() {
    var variantId = sizeBtn.getAttribute('data-variant-id');
    var sellingPlan = currentPlan();
    // Hand off to the cart module when it is listening. Payload is variantId, plus
    // sellingPlanId in subscribe mode only.
    var detail = { variantId: variantId };
    if (sellingPlan) detail.sellingPlanId = sellingPlan;
    window.dispatchEvent(new CustomEvent('gx:add-to-cart', { detail: detail }));
    // Fallback direct add when no cart module has registered.
    if (!window.__gxCartModule) {
      var line = { id: Number(variantId), quantity: 1 };
      if (sellingPlan) line.selling_plan = Number(sellingPlan);
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/cart';   // safety net: never leave an add with no feedback
      }).catch(function () {});
    }
  }
  root.querySelectorAll('[data-gx-add-cta]').forEach(function (b) {
    b.addEventListener('click', addToCart);
  });

  // ----- gallery -----
  // Two slides: front jug (fill, review overlay on) and back label (fit, overlay off).
  var mainImg = $('[data-gx-main-img]');
  var overlay = $('[data-gx-review-overlay]');
  var thumbs = root.querySelectorAll('[data-gx-gallery] .thumb');
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.setAttribute('data-on', 'false'); });
      t.setAttribute('data-on', 'true');
      if (mainImg) {
        mainImg.src = t.getAttribute('data-src');
        mainImg.alt = t.getAttribute('data-alt') || '';
        mainImg.classList.toggle('jfc-fit', t.getAttribute('data-fit') === 'contain');
      }
      if (overlay) overlay.style.display = i === 0 ? '' : 'none';
    });
  });

  // ----- common questions accordion -----
  var cq = $('[data-gx-cq]');
  if (cq) {
    cq.querySelectorAll('.gx-cq-item').forEach(function (item) {
      var q = item.querySelector('.gx-cq-q');
      var a = item.querySelector('.gx-cq-a');
      q.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        cq.querySelectorAll('.gx-cq-item').forEach(function (o) {
          o.setAttribute('data-open', 'false');
          o.querySelector('.gx-cq-q').setAttribute('aria-expanded', 'false');
          o.querySelector('.gx-cq-a').style.maxHeight = '0';
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          q.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = '520px';
        }
      });
    });
    // Tablet (1024px and below): relocate CQ below the buy box; desktop: keep under gallery.
    var galleryCol = root.querySelector('.gallery-col');
    var mq = window.matchMedia('(max-width: 1024px)');
    var placeCQ = function () {
      if (mq.matches) { root.appendChild(cq); }
      else if (galleryCol && cq.parentElement !== galleryCol) { galleryCol.appendChild(cq); }
    };
    placeCQ();
    mq.addEventListener('change', placeCQ);
  }

  // ----- sticky mobile buy bar -----
  var cta = root.querySelector('.add-cta');
  var mbar = $('[data-gx-mobile-bar]');
  if (cta && mbar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      mbar.setAttribute('data-show', entries[0].isIntersecting ? 'false' : 'true');
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(cta);
  }

  // ----- ship-by countdown (next 3pm CT) + ZIP transit -----
  var shipLine = $('[data-gx-ship-line]');
  var zipInput = $('[data-gx-ship-zip]');
  var zipOk = $('[data-gx-ship-ok]');
  function zipTransit(z) {
    if (!/^\d{5}$/.test(z)) return 3;
    return ({ '7': 2, '6': 2, '4': 3, '5': 3, '3': 3, '2': 4, '8': 4, '0': 4, '1': 4, '9': 5 })[z[0]] || 3;
  }
  var isBiz = function (d) { return d.getDay() >= 1 && d.getDay() <= 5; };
  var addBiz = function (date, n) { var d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; };
  function renderShip() {
    if (!shipLine) return;
    var zip = zipInput ? zipInput.value : '';
    var days = zipTransit(zip);
    var c = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    var cutoff = new Date(c); cutoff.setHours(15, 0, 0, 0);
    if (c >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var todays3pm = new Date(c); todays3pm.setHours(15, 0, 0, 0);
    var shipDate = (isBiz(c) && c < todays3pm) ? new Date(c) : addBiz(c, 1);
    var delivery = addBiz(shipDate, days);
    // Emit BOTH date forms; CSS shows dd-full on desktop and dd-short (short) on phones.
    var dFull = delivery.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    var dShort = delivery.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    var dStr = '<span class="dd-full">' + dFull + '</span><span class="dd-short">' + dShort + '</span>';
    var ms = cutoff - c;
    var h = Math.floor(ms / 3600000); ms -= h * 3600000;
    var m = Math.floor(ms / 60000);
    var countdown = (h > 0 ? h + (h === 1 ? ' hr ' : ' hrs ') : '') + m + (m === 1 ? ' min' : ' mins');
    // Verbose countdown on desktop (dd-full), COMPACT on phones (dd-short), toggled by the same
    // .ship-cutoff .dd-full/.dd-short rules as the date.
    var countdownShort = (h > 0 ? h + 'h ' : '') + m + 'm';
    var cStr = '<span class="dd-full">' + countdown + '</span><span class="dd-short">' + countdownShort + '</span>';
    // sc-a/sc-b spans stay inline; they are the wrap points for the <=340 guard.
    shipLine.innerHTML = '<span class="sc-a">FREE delivery <strong>' + dStr + '</strong>.</span> <span class="sc-b">Order within <strong class="sc-count">' + cStr + '</strong></span>';
  }
  if (zipInput) {
    try { zipInput.value = localStorage.getItem('gx_zip') || ''; } catch (e) {}
    // 128px while empty (fits "Enter Zip to Confirm"), then (length + 0.5)ch once digits are
    // typed so the underline tracks the value.
    var sizeZip = function () { zipInput.style.width = zipInput.value ? (zipInput.value.length + 0.5) + 'ch' : '128px'; };
    sizeZip();
    zipInput.addEventListener('input', function () {
      zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
      sizeZip();
      var ok = /^\d{5}$/.test(zipInput.value);
      if (zipOk) zipOk.style.display = ok ? '' : 'none';
      try { if (ok) localStorage.setItem('gx_zip', zipInput.value); } catch (e) {}
      renderShip();
    });
    if (/^\d{5}$/.test(zipInput.value) && zipOk) zipOk.style.display = '';
  }
  renderShip();
  setInterval(renderShip, 30000);

  render();
})();
